import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthUserModel, ProjectModel } from '../../../../models';
import { SendEmailFormComponent } from '../../../../pages/project/export/components/send-email-form/send-email-form.component';
import { AuthService } from '../../../../services/auth.service';
import { Mail } from 'lucide-angular';

@Component({
	selector: 'app-email-preview',
	templateUrl: './email-preview.component.html',
	styleUrls: ['./email-preview.component.scss'],
})

export class EmailPreviewComponent {
	@Input() public project: ProjectModel;
	@Input() public emailFormComponent: SendEmailFormComponent;

	protected readonly Mail = Mail;

	private user: AuthUserModel;

	constructor(authService: AuthService) {
		authService.userDetailsObservable.pipe(takeUntilDestroyed()).subscribe(user => (this.user = user));
	}

	public toggleModal(e: MouseEvent) {
		e.preventDefault();
		e.stopPropagation();

		if (this.emailFormComponent && this.project) {
			this.emailFormComponent.project = this.project;

			if (this.user) {
				this.emailFormComponent.user = this.user;
				this.emailFormComponent.endpoint = 'project-update';
				this.emailFormComponent.open();
			}
		}
	}
}
